























































































import ChangePassword from '@/components/ChangePassword.vue';
import Login from '@/components/common/Login.vue';
import UserProfileQuery from '@/graphql/queries/userProfile.gql';
import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Login,
    ChangePassword,
  },
})
export default class Profile extends Vue {
  public userProfile: {
    email?: string;
    name?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zip?: string;
  } = {};

  public quotes: Array<{
    id: string;
    price: number;
    isAccepted: boolean;
    clinicName: string;
    state: string;
    additionalTravelers: number;
    createdAt: Date;
    procedures: Array<{ name: string; price: number }>;
    flights?: Array<{ name: string; number: string }>;
    campaign?: {
      id: string;
      name: string;
      goal: number;
      raised: number;
      endDateTime: Date;
    };
  }> = [];

  public firstName(name: string) {
    if (!name) {
      return '';
    }

    const firstSpace = name.indexOf(' ');
    return firstSpace > -1 ? name.substr(0, firstSpace) : name;
  }

  public formatPrice(price: number) {
    return (price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  public formatDate(date: string | Date) {
    return new Date(date).toLocaleDateString(undefined, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  public quoteTotal(quoteNumber: number) {
    return (
      this.quotes[quoteNumber].price ||
      this.quotes[quoteNumber].procedures.reduce((t, p) => p.price + t, 0)
    );
  }

  public quoteStatus(quoteNumber: number) {
    return this.quotes[quoteNumber].state;
  }

  public mounted() {
    request(UserProfileQuery)
      .then(({ data }) => {
        if (!data.user) {
          throw new Error('User is undefined');
        }

        this.userProfile = Object.assign({}, data.user.profile, {
          email: data.user.email,
        });
        this.quotes = (data.user.quotes || []).map((q: any) => ({
          ...q,
          clinicName: q.clinic.name,
          procedures: q.procedures.map((p: any) => ({ ...p, ...p.procedure })),
        }));
        this.quotes = this.quotes.sort(
          (a, b) => +new Date(b.createdAt) - +new Date(a.createdAt)
        );
      })
      .catch(e => {
        console.error(e);
        this.$router.back();
      });
  }
}
